import React, { useCallback } from 'react'
import TableRowStatus from 'routes/Transits/Table/TableRowStatus'
import { DeclarationStatusEnum } from 'types/IDeclaration'
import { useTranslation } from 'react-i18next'
import NavigationBarInfo from 'features/declaration/form/components/NavigationBarInfo'
import NavigationBarTabs from 'features/declaration/form/components/NavigationBarTabs'
import ConfirmationModal from '../../../../../components/ConfirmationModal'
import useDeclarationEditorActions from '../../components/useDeclarationEditorActions'
import ConsignmentSummary from '../../../consignment/components/ConsignmentSummary'
import EnsDeclarationTabs from './EnsDeclarationTabs'
import EnsEditorActions from './EnsEditorActions'
import DeclarationLayout from '../../components/DeclarationLayout'

function EnsEditor() {
  const { t } = useTranslation()
  const {
    form,
    declaration,
    activeTab,
    goToTab,
    interactionsLocked,
    directoTabRef,

    invokeEditorAction,

    grossMassCheckModalOps,
    duplicationModal,
    createTransitFromEnsModal,
  } = useDeclarationEditorActions({ isEns: true })

  const getGrossMassCheckConfirmationMessage = useCallback(() => {
    const grossMassValidationResult = grossMassCheckModalOps.result
    if (!grossMassValidationResult || grossMassValidationResult.valid) return ''

    const { consignmentRequirement } = grossMassValidationResult
    if (consignmentRequirement) {
      return t('declaration.p5.errors.grossMassDifference', {
        actual: consignmentRequirement.actual.toFixed(3),
        expected: consignmentRequirement.expectedMinimum.toFixed(3),
      })
    }

    return t('declaration.p5.errors.grossMassDifference', { context: 'houseConsignment' })
  }, [grossMassCheckModalOps.result, t])

  return (
    <>
      <DeclarationLayout
        interactionsLocked={interactionsLocked}
        headerLeft={<NavigationBarInfo transitOperation={declaration?.transitOperation} declarationKind="ens" />}
        headerCenter={(
          <NavigationBarTabs
            onTabChange={goToTab}
            activeTab={activeTab}
          />
        )}
        footerLeft={<ConsignmentSummary consignmentId={declaration?.consignment?.id ?? null} />}
        footerRight={(
          <>
            <TableRowStatus value={declaration?.transitOperation?.status ?? DeclarationStatusEnum.DRAFT.toString()} asBadge />
            <EnsEditorActions onAction={invokeEditorAction} interactionsLocked={interactionsLocked} />
          </>
        )}
      >
        <EnsDeclarationTabs
          form={form}
          activeTab={activeTab}
          directoTabRef={directoTabRef}
          interactionsLocked={interactionsLocked}
        />
      </DeclarationLayout>

      <ConfirmationModal
        title={t('declaration.p5.duplicate')}
        messageBody={t('messages.duplicateDocumentsMessage')}
        warning={t('declaration.p5.unsavedChangesLostWarning')}
        isVisible={duplicationModal.isOpen}
        isLoading={duplicationModal.isSubmitting}
        toggleVisibility={duplicationModal.close}
        onConfirmation={duplicationModal.confirm}
        onRejection={duplicationModal.reject}
        error={duplicationModal.error}
      />
      <ConfirmationModal
        title={t('declaration.p5.createTransitFromEns')}
        messageBody={t('messages.duplicateDocumentsMessage')}
        warning={t('declaration.p5.unsavedChangesLostWarning')}
        isVisible={createTransitFromEnsModal.isOpen}
        isLoading={createTransitFromEnsModal.isSubmitting}
        toggleVisibility={createTransitFromEnsModal.close}
        onConfirmation={createTransitFromEnsModal.confirm}
        onRejection={createTransitFromEnsModal.reject}
      />
      <ConfirmationModal
        title={t('declaration.p5.goodsIssues')}
        messageBody={getGrossMassCheckConfirmationMessage()}
        isVisible={grossMassCheckModalOps.isOpen}
        isLoading={false}
        toggleVisibility={grossMassCheckModalOps.reject}
        onConfirmation={grossMassCheckModalOps.confirm}
        onRejection={grossMassCheckModalOps.reject}
      />
    </>
  )
}

export default EnsEditor
